import {Component, computed, inject, input} from '@angular/core';
import {rxResource} from '@angular/core/rxjs-interop';
import {AdminProjectChapterMetrics} from '@frontend/shared-api';
import {DirectusService, DirectusTranslation} from '@frontend/directus';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {LoadingComponent} from '../../../../../shared/components/loading/loading.component';
import {ChapterProgressRingComponent} from '../chapter-progress-ring/chapter-progress-ring.component';

@Component({
  selector: 'app-chapter-progress-grid',
  templateUrl: './chapter-progress-grid.component.html',
  imports: [TranslateDirectusPipe, LoadingComponent, ChapterProgressRingComponent],
})
export class ChapterProgressGridComponent {
  private readonly directusService = inject(DirectusService);

  chapterMetrics = input.required<AdminProjectChapterMetrics[]>();

  private readonly chapterTitlesResource = rxResource({
    stream: () => this.directusService.loadChapters(),
  });

  protected readonly chapterTranslationsByType = computed(() => {
    const translationsByType = new Map<string, DirectusTranslation[] | undefined>();
    for (const chapter of this.chapterTitlesResource.value() ?? []) {
      translationsByType.set(chapter.chapterConfigId ?? '', chapter.translations);
    }
    return translationsByType;
  });

  protected readonly isLoading = computed(() => this.chapterTitlesResource.isLoading());
}
